import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { acceptEmployeeInvitation } from "../../common/api/tradePointApi";
import AlertBox from "../../shared/Ui/AlertBox/AlertBox";

function AcceptInvitation() {
    const navigate = useNavigate();
    const { token } = useParams();
    const [alertOpen, setAlertOpen] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const acceptInvitation = async () => {
            try {
                setIsLoading(true);
                if (!token) {
                    throw new Error("Токен приглашения не найден");
                }
                await acceptEmployeeInvitation(token);
                setAlertOpen({
                    status: "SUCCESS",
                    message: "Приглашение успешно принято",
                });
                // Redirect to login page after successful acceptance
                setTimeout(() => {
                    navigate("/auth");
                }, 2000);
            } catch (error: any) {
                setAlertOpen({
                    status: "error",
                    message: error.response?.data?.message || "Ошибка при принятии приглашения",
                });
            } finally {
                setIsLoading(false);
            }
        };

        acceptInvitation();
    }, [token, navigate]);

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
            {isLoading ? (
                <div className="flex flex-col items-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mb-4"></div>
                    <p className="text-gray-600">Обработка приглашения...</p>
                </div>
            ) : (
                <div className="bg-white p-8 rounded-lg shadow-md">
                    <h1 className="text-2xl font-semibold mb-4">Приглашение в торговую точку</h1>
                    <p className="text-gray-600">
                        {alertOpen?.status === "SUCCESS" 
                            ? "Вы успешно приняли приглашение. Сейчас вы будете перенаправлены на страницу входа."
                            : "Произошла ошибка при обработке приглашения."}
                    </p>
                </div>
            )}

            {alertOpen && (
                <AlertBox
                    isOpen={alertOpen}
                    setIsOpen={setAlertOpen}
                />
            )}
        </div>
    );
}

export default AcceptInvitation; 